// Couleurs par catégorie - Style magazine moderne
export const CATEGORY_COLORS: Record<string, {
  bg: string
  text: string
  border: string
  hover: string
}> = {
  'rep-dom': {
    bg: 'bg-red-600',
    text: 'text-red-600',
    border: 'border-red-600',
    hover: 'hover:bg-red-700'
  },
  'canada': {
    bg: 'bg-red-700',
    text: 'text-red-700',
    border: 'border-red-700',
    hover: 'hover:bg-red-800'
  },
  'monde': {
    bg: 'bg-blue-600',
    text: 'text-blue-600',
    border: 'border-blue-600',
    hover: 'hover:bg-blue-700'
  },
  'economie': {
    bg: 'bg-green-600',
    text: 'text-green-600',
    border: 'border-green-600',
    hover: 'hover:bg-green-700'
  },
  'politique-rd': {
    bg: 'bg-purple-600',
    text: 'text-purple-600',
    border: 'border-purple-600',
    hover: 'hover:bg-purple-700'
  },
  'environnement': {
    bg: 'bg-emerald-600',
    text: 'text-emerald-600',
    border: 'border-emerald-600',
    hover: 'hover:bg-emerald-700'
  },
  'sciences-tech': {
    bg: 'bg-indigo-600',
    text: 'text-indigo-600',
    border: 'border-indigo-600',
    hover: 'hover:bg-indigo-700'
  }
}

export function getCategoryColor(category: string) {
  return CATEGORY_COLORS[category] || CATEGORY_COLORS[category.toLowerCase()] || CATEGORY_COLORS['monde']
}

// Durée formatée pour vidéos (mock pour l'instant)
export function formatVideoDuration(seconds?: number): string {
  if (!seconds) return '3:45' // Mock duration
  const mins = Math.floor(seconds / 60)
  const secs = seconds % 60
  return `${mins}:${secs.toString().padStart(2, '0')}`
}